/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { AnyAction, Reducer } from 'redux';
import { takeEvery, put } from 'redux-saga/effects';
import { ILooseObject } from '@interface/loose-object';
import { GetUserRelation, GetUserCount } from '@lib/versum';

export interface IUserCount {
  relation: {
    viewer: boolean;
    user: boolean;
  };
  count: {
    created: number;
    owned: number;
    collaborations: number;
    boards: number;
    followers: number;
    following: number;
    favourites: number;
  };
}

export const initialState: IUserCount = {
  relation: {
    viewer: false, // viewer follows user
    user: false, // user follows viewer
  },
  count: {
    created: 0,
    owned: 0,
    collaborations: 0,
    boards: 0,
    followers: 0,
    following: 0,
    favourites: 0,
  },
};

export enum actions {
  USER_UPDATE_NEW_USER = 'USER_UPDATE_NEW_USER', // a new user comes in
  USER_UPDATE_USER = 'USER_UPDATE_USER', // update current user
  USER_SET_RELATION = 'USER_SET_RELATION',
  USER_SET_COUNT = 'USER_SET_COUNT',
}

export const reducer: Reducer<IUserCount, AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    case actions.USER_SET_RELATION:
      return { ...state, relation: { ...action.payload } };
    case actions.USER_SET_COUNT:
      return { ...state, count: { ...action.payload } };
    default:
      return state;
  }
};

interface ISagaEvent {
  type: string;
  payload: any;
}

function* updateNewUser(event: ISagaEvent) {
  const relation: ILooseObject = yield GetUserRelation(event.payload.viewer, event.payload.userid);
  const count: ILooseObject = yield GetUserCount(event.payload.userid);

  yield put({ type: actions.USER_SET_RELATION, payload: relation });
  yield put({ type: actions.USER_SET_COUNT, payload: count });
}

function* updateUserCount(event: ISagaEvent) {
  const response: ILooseObject = yield GetUserCount(event.payload);
  yield put({ type: actions.USER_SET_COUNT, payload: response });
}

export function* saga() {
  yield takeEvery(actions.USER_UPDATE_NEW_USER, updateNewUser);
  yield takeEvery(actions.USER_UPDATE_USER, updateUserCount);
}
